import React, { createContext, useContext, useState } from 'react'

interface WPPContextData {
    isWPPOpen: boolean
    setOpenWpp: (open: boolean) => void
}

interface WPPProviderProps {
    children: React.ReactNode
}

const WPPContext = createContext<WPPContextData>({} as WPPContextData)

export function WPPProvider({ children }: WPPProviderProps) {
    const [isWPPOpen, setIsWPPOpen] = useState(false)

    const setOpenWpp = (open: boolean) => {
        setIsWPPOpen(open)
    }

    return (
        <WPPContext.Provider value={{ isWPPOpen, setOpenWpp }}>
            {children}
        </WPPContext.Provider>
    )
}

export function useWPP() {
    const context = useContext(WPPContext)

    if (!context) {
        throw new Error('useWPP must be used within a WPPProvider')
    }

    return context
}
